import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import logoicon from "SharedImages/tuutuum-logo-icon.png";
import SocialLinks from "./SocialLinks";
import securepayment from "../assets/images/secure-payment.png";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-white shadow-inner p-3 pt-16 w-full">
      <div className="max-w-screen-xl mx-auto space-y-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.2fr_1.2fr_1.2fr_0.5fr] gap-5 items-start mx-8 sm:mx-10">
          {/* Tuutuum */}
          <div className="flex flex-col items-center md:items-start text-center lg:text-left">
            <a href="/">
              <img
                src={logoicon}
                alt="TuuTuum Logo"
                className="h-10 mb-2 block w-auto transition ease-in-out hover:scale-90"
              />
            </a>
            <p className="text-lg mb-4">{t("company.slogan")}</p>
            <span className="text-2xl">
              <SocialLinks />
            </span>
          </div>

          {/* Payments & security icons */}
          <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
            <h3 className="text-lg font-bold mb-3">
              {t("payment_and_security")}
            </h3>
            <div className="flex flex-row space-x-3 mb-2">
              <img
                src="https://www.mastercard.se/content/dam/public/mastercardcom/eu/se/logos/mc-logo-52.svg"
                alt="Mastercard"
                className="h-6"
              />
              <img
                src="https://cdn.visa.com/v2/assets/images/logos/visa/blue/logo.png"
                alt="Visa"
                className="h-6"
              />
            </div>
            <img src={securepayment} alt="Secure Payment" className="h-11" />
          </div>

          {/* Company info */}
          <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
            <h3 className="text-lg font-bold">{t("company.information")}</h3>
            <ul role="list" className="space-y-1.5">
              <li>
                <span className="font-bold">{t("company.name")}</span>
              </li>
              <li className="text-sm">
                <span className="font-bold">{t("company.reg_no_title")}</span>
                {t("company.reg_no")}
              </li>
              {/* <li className="text-sm">
                <strong>{t("company.phone_title")}</strong>
                <Trans
                  i18nKey="company.phone"
                  components={{
                    a: <a href="tel:+46707216910" />,
                  }}
                >
                  {t("company.phone")}
                </Trans>
              </li> */}
              <li className="text-sm">
                <span className="font-bold">{t("company.address_title")}</span>
                {t("company.address")}
              </li>
              <li className="text-sm">
                <strong>{t("company.email_title")}</strong>
                <Trans
                  i18nKey="company.customer_email"
                  components={{
                    a: (
                      <a href="mailto:kundtjanst@tuutuum.se">
                        {t("company.customer_email")}
                      </a>
                    ),
                  }}
                >
                  {t("company.customer_email")}
                </Trans>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
            <h3 className="text-lg font-bold">{t("links")}</h3>
            <ul role="list" className="space-y-1.5">
              <li className="text-sm">
                <Link to={`/terms#${t("hashes.privacy")}`}>
                  {t("privacy_policy")}
                </Link>
              </li>
              <li className="text-sm">
                <Link to={`/terms#${t("hashes.delivery")}`}>
                  {t("terms_of_delivery")}
                </Link>
              </li>
              <li className="text-sm">
                <Link to={`/terms#${t("hashes.purchase")}`}>
                  {t("terms_of_purchase")}
                </Link>
              </li>
              <li className="text-sm">
                <Link to="/contact">{t("contact_us")}</Link>
              </li>
              <li className="text-sm">
                <Link to={`/contact#${t("hashes.faq")}`}>
                  {t("faq")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <hr className="max-w-screen-xl mx-auto mt-8 mb-4 border-teal-200" />

      <div className="text-xs text-center">
        <Link to="/" className="text-center">
          <p>{t("copyright")}</p>
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
